import { render, staticRenderFns } from "./KuaishouTextAd.vue?vue&type=template&id=5e369e43&scoped=true&"
import script from "./KuaishouTextAd.vue?vue&type=script&lang=js&"
export * from "./KuaishouTextAd.vue?vue&type=script&lang=js&"
import style0 from "./KuaishouTextAd.vue?vue&type=style&index=0&id=5e369e43&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e369e43",
  null
  
)

export default component.exports